import React, { useState, useRef, useEffect } from "react";
import { createPortal } from "react-dom";
import { useNavigate } from "react-router-dom";
import { usePermission } from "../../hooks/usePermission";
import "./SearchOverlay.css";

// All sidebar page links grouped by category
const ALL_PAGES = [
  // Main Pages
  {
    name: "Dashboard",
    path: "/dashboard",
    icon: "fa-solid fa-table-cells-large",
    category: "Pages",
    permission: "dashboard-view",
  },
  {
    name: "Members",
    path: "/users",
    icon: "fa-solid fa-user",
    category: "Pages",
    permission: "members-list",
  },
  {
    name: "Meeting Schedules",
    path: "/weekly-meetings",
    icon: "fa-regular fa-calendar-check",
    category: "Pages",
    permission: "meeting-schedules-list",
  },
  {
    name: "Meeting Fees",
    path: "/meeting-fees",
    icon: "fa-solid fa-calendar-days",
    category: "Pages",
    permission: "meeting-fees-list",
  },
  {
    name: "121s",
    path: "/one-to-one",
    icon: "fa-solid fa-comments",
    category: "Pages",
    permission: "121s-list",
  },
  {
    name: "RFLs",
    path: "/referrals",
    icon: "fa-solid fa-share-nodes",
    category: "Pages",
    permission: "referrals-list",
  },
  {
    name: "TYNs",
    path: "/tyfcbs",
    icon: "fa-regular fa-face-smile",
    category: "Pages",
    permission: "tyfcbs-list",
  },
  {
    name: "Buddy Pairs",
    path: "/buddy-pairs",
    icon: "fa-solid fa-user-group",
    category: "Pages",
    permission: "buddy-pairs-list",
  },
  {
    name: "Buddy Habit Report",
    path: "/buddy-habit-report",
    icon: "fa-solid fa-clipboard-check",
    category: "Pages",
    permission: "buddy-habit-report-list",
  },
  {
    name: "Complaints",
    path: "/complaints",
    icon: "fa-solid fa-flag",
    category: "Pages",
    permission: "complaints-list",
  },
  {
    name: "Grievances",
    path: "/grievances",
    icon: "fa-solid fa-scale-balanced",
    category: "Pages",
    permission: "complaints-list",
  },
  {
    name: "Events",
    path: "/events",
    icon: "fa-regular fa-calendar-days",
    category: "Pages",
    permission: "events-list",
  },
  {
    name: "News Feed",
    path: "/news",
    icon: "fa-solid fa-newspaper",
    category: "Pages",
    permission: "news-list",
  },
  {
    name: "Leads",
    path: "/feed-posts",
    icon: "fa-solid fa-bullseye",
    category: "Pages",
    permission: "feed-posts-list",
  },
  {
    name: "Incomes",
    path: "/incomes",
    icon: "fa-solid fa-sack-dollar",
    category: "Pages",
    permission: "incomes-list",
  },
  {
    name: "Expenses",
    path: "/expenses",
    icon: "fa-solid fa-credit-card",
    category: "Pages",
    permission: "expenses-list",
  },
  {
    name: "Sponsors",
    path: "/sponsors",
    icon: "fa-solid fa-handshake",
    category: "Pages",
    permission: "sponsors-list",
  },
  {
    name: "Testimonials",
    path: "/testimonials",
    icon: "fa-solid fa-comment-dots",
    category: "Pages",
    permission: "testimonials-list",
  },
  {
    name: "Roles & Permissions",
    path: "/roles",
    icon: "fa-solid fa-user-shield",
    category: "Pages",
    permission: "roles-list",
  },
  {
    name: "Settings",
    path: "/settings",
    icon: "fa-solid fa-gear",
    category: "Pages",
    permission: "settings-list",
  },

  // Visitors
  {
    name: "Visitors - General",
    path: "/visitors/general",
    icon: "fa-solid fa-user-group",
    category: "Visitors",
    permission: "visitors-general-list",
  },
  {
    name: "Visitors - Chief Guest",
    path: "/visitors/chief-guest",
    icon: "fa-solid fa-user-tie",
    category: "Visitors",
    permission: "visitors-chief-guest-list",
  },
  {
    name: "Visitors - Inductions",
    path: "/visitors/inductions",
    icon: "fa-solid fa-user-plus",
    category: "Visitors",
    permission: "visitors-inductions-list",
  },
  {
    name: "Visitors - Power Date",
    path: "/visitors/power-date",
    icon: "fa-solid fa-calendar-check",
    category: "Visitors",
    permission: "visitors-power-date-list",
  },

  // Reports
  {
    name: "Reports - TYNs",
    path: "/reports/tyfcbs",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-tyns-list",
  },
  {
    name: "Reports - BIZ Given",
    path: "/reports/biz-given",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-biz-given-list",
  },
  {
    name: "Reports - 121s",
    path: "/reports/one-to-one",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-121s-list",
  },
  {
    name: "Reports - RFLs",
    path: "/reports/referrals",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-referrals-list",
  },
  {
    name: "Reports - Visitors",
    path: "/reports/visitors",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-visitors-list",
  },
  {
    name: "Reports - Reward Points",
    path: "/reports/points",
    icon: "fa-solid fa-trophy",
    category: "Reports",
    permission: "reports-reward-points",
  },
  {
    name: "Reports - Chapter Pending Fee",
    path: "/reports/fees",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-fees-list",
  },
  {
    name: "Reports - Attendance",
    path: "/reports/attendance",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-attendance-list",
  },
  {
    name: "Reports - Overall",
    path: "/reports/overall",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-overall-list",
  },
  {
    name: "Reports - Membership Expiry & Renewals",
    path: "/reports/membership-expiry-renewals",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-membership-expiry-renewal-list",
  },
  {
    name: "Reports - Incomes & Expenses Ledger",
    path: "/reports/ledger",
    icon: "fa-solid fa-chart-column",
    category: "Reports",
    permission: "reports-ledger-list",
  },

  // Masters
  {
    name: "Countries",
    path: "/countries",
    icon: "fa-solid fa-earth-americas",
    category: "Masters",
    permission: "countries-list",
  },
  {
    name: "States",
    path: "/states",
    icon: "fa-solid fa-map",
    category: "Masters",
    permission: "states-list",
  },
  {
    name: "Regions",
    path: "/regions",
    icon: "fa-solid fa-location-dot",
    category: "Masters",
    permission: "regions-list",
  },
  {
    name: "Chapters",
    path: "/chapters",
    icon: "fa-solid fa-book-open",
    category: "Masters",
    permission: "chapters-list",
  },
  {
    name: "Country Admins",
    path: "/country-admin-users",
    icon: "fa-regular fa-circle-user",
    category: "Masters",
    permission: "country-admins-list",
  },
  {
    name: "State Admins",
    path: "/state-admin-users",
    icon: "fa-regular fa-circle-user",
    category: "Masters",
    permission: "state-admins-list",
  },
  {
    name: "Region Admins",
    path: "/region-admin-users",
    icon: "fa-regular fa-circle-user",
    category: "Masters",
    permission: "region-admins-list",
  },
  {
    name: "Chapter Admins",
    path: "/chapter-admin-users",
    icon: "fa-regular fa-circle-user",
    category: "Masters",
    permission: "chapter-admins-list",
  },
  {
    name: "User Roles",
    path: "/user-roles",
    icon: "fa-solid fa-id-card",
    category: "Masters",
    permission: "user-roles-list",
  },
  {
    name: "Business Category",
    path: "/category",
    icon: "fa-solid fa-layer-group",
    category: "Masters",
    permission: "business-category-list",
  },
  {
    name: "Income Category",
    path: "/income-category",
    icon: "fa-solid fa-tags",
    category: "Masters",
    permission: "income-category-list",
  },
  {
    name: "Expense Category",
    path: "/expense-category",
    icon: "fa-solid fa-tags",
    category: "Masters",
    permission: "expense-category-list",
  },
  {
    name: "Leads Category",
    path: "/posts-category",
    icon: "fa-solid fa-tags",
    category: "Masters",
    permission: "posts-category-list",
  },
  {
    name: "Sponsors Category",
    path: "/sponsors-category",
    icon: "fa-solid fa-tags",
    category: "Masters",
    permission: "sponsors-category-list",
  },
  {
    name: "Blood Groups",
    path: "/blood-groups",
    icon: "fa-solid fa-droplet",
    category: "Masters",
    permission: "blood-groups-list",
  },
  {
    name: "Habits",
    path: "/habits",
    icon: "fa-solid fa-list-check",
    category: "Masters",
    permission: "habits-list",
  },
  {
    name: "Crowns",
    path: "/crowns",
    icon: "fa-solid fa-crown",
    category: "Masters",
    permission: "crowns-list",
  },
  {
    name: "Chapter Finance Access",
    path: "/chapter-finance-access",
    icon: "fa-solid fa-wallet",
    category: "Masters",
    permission: "chapter-finance-access-list",
  },
];


const SearchOverlay = ({ isOpen, onClose }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const inputRef = useRef(null);
  const listRef = useRef(null);
  const navigate = useNavigate();
  const { hasPermission } = usePermission();

  // Filter pages: first by permission, then by search term
  const allowedPages = ALL_PAGES.filter((page) => hasPermission(page.permission));

  const filteredPages = searchTerm.trim()
    ? allowedPages.filter((page) =>
        page.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
    : allowedPages;

  // Group filtered pages by category
  const groupedPages = filteredPages.reduce((acc, page) => {
    if (!acc[page.category]) {
      acc[page.category] = [];
    }
    acc[page.category].push(page);
    return acc;
  }, {});

  // Flat list for keyboard navigation
  const flatList = filteredPages;

  // Focus input when overlay opens
  useEffect(() => {
    if (isOpen) {
      setSearchTerm("");
      setActiveIndex(0);
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    }
  }, [isOpen]);

  // Scroll active item into view
  useEffect(() => {
    const activeEl = listRef.current?.querySelector(
      ".search-result-item.active",
    );
    if (activeEl) {
      activeEl.scrollIntoView({ block: "nearest" });
    }
  }, [activeIndex]);

  const handleKeyDown = (e) => {
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) => Math.min(prev + 1, flatList.length - 1));
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) => Math.max(prev - 1, 0));
    } else if (e.key === "Enter") {
      e.preventDefault();
      if (flatList[activeIndex]) {
        handleNavigate(flatList[activeIndex].path);
      }
    } else if (e.key === "Escape") {
      onClose();
    }
  };

  const handleNavigate = (path) => {
    navigate(path);
    onClose();
  };

  if (!isOpen) return null;

  let globalIndex = 0;

  return createPortal(
    <>
      <div className="search-overlay-backdrop" onClick={onClose}></div>
      <div className="search-overlay-modal">
        {/* Search Input */}
        <div className="search-overlay-header">
          <i className="fa-solid fa-magnifying-glass search-overlay-icon"></i>
          <input
            ref={inputRef}
            type="text"
            className="search-overlay-input"
            placeholder="Type a command or search..."
            value={searchTerm}
            onChange={(e) => {
              setSearchTerm(e.target.value);
              setActiveIndex(0);
            }}
            onKeyDown={handleKeyDown}
          />
          <button className="search-overlay-close" onClick={onClose}>
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        {/* Results List */}
        <div className="search-overlay-results" ref={listRef}>
          {Object.keys(groupedPages).length === 0 ? (
            <div className="search-no-results">
              <div className="search-no-results-icon">
                <i className="fa-solid fa-magnifying-glass"></i>
              </div>
              <h6>No results found</h6>
              <p>We couldn't find anything matching "{searchTerm}".</p>
            </div>
          ) : (
            Object.entries(groupedPages).map(([category, pages]) => (
              <div key={category} className="search-section">
                <div className="search-result-category">{category}</div>
                <div className="search-cards-grid">
                  {pages.map((page) => {
                    const currentIndex = globalIndex++;
                    return (
                      <div
                        key={page.path}
                        className={`search-result-item ${currentIndex === activeIndex ? "active" : ""}`}
                        onClick={() => handleNavigate(page.path)}
                        onMouseEnter={() => setActiveIndex(currentIndex)}
                      >
                        <div className="search-result-item-icon">
                          <i className={page.icon}></i>
                        </div>
                        <div className="search-result-item-content">
                          <div className="search-result-item-name">
                            {page.name}
                          </div>
                          <div className="search-result-item-desc">
                            View {page.name}
                          </div>
                        </div>
                        <i className="fa-solid fa-chevron-right search-result-item-arrow"></i>
                      </div>
                    );
                  })}
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </>,
    document.body,
  );
};

export default SearchOverlay;
